import {
  Box,
  Button,
  Dialog,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import styles1 from "../../../styles/pages/user/CopywritePendingTitlingTable.module.scss";
import styles from "../../../styles/pages/home.module.scss";
import assest from "../../../json/assest";
import { useQuery } from "react-query";

import {
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setMonth,
  setYear,
  setSubmitPlace,
  setUserId,
  setManagerId,
  setQualityTeamId,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
} from "../../../redux-toolkit/slices/qc.confirm.approved.approved.slice";
import "plyr/dist/plyr.css"; // Import Plyr styles
import Plyr from "plyr";
import Hls from "hls.js";
import WatchVideoModal from "../../VideoPages/pages/WatchVideoModal";
import VideoPageFullModal from "../../VideoPages/pages/VideoPageFullModal";
import Filter from "../../Filter/Filter";
import QcWebsiteonlyRejectedFilterModal from "../../FilterModal/QcWebsiteonlyRejectedFilterModal";
import PaginationTwo from "../../UtilitiesComponent/PaginationTwo";
import SearchOopsIcon from "../../../public/assets/icons/SearchOopsIcon";
import { useAppSelector } from "../../../hooks/useAppSelector";
import ApiLoader from "../../Loaders/ApiLoader";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcTime,
} from "../../../lib/functions/utils.lib";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import NoResultTwo from "../../NoResult/NoResultTwo";
import { CopywritersDashboardpendingtitlingpageMutation } from "../../../api/functions/copywritersDashboard.api";
import CopywritePendingTitlingFilter from "../../AllFilterRow/CopywritePageFilter/CopywritePendingTitlingFilter";
import { CopywritersDashboardPendingRevisionMutation } from "../../../api/functions/copywritersDashboard.api";
import CopywritePendingRivisionFilter from "../../AllFilterRow/CopywritePageFilter/CopywritePendingRivisionFilter";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const PendingTitlingRevisedTable = (props) => {
  const {
    // page,
    has_note,
    unreachable_submitter,
    hasMessage,
    month,
    year,
    submit_place,
    user_id,
    manager_id,
    quality_team_id,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
    search,
  } = useAppSelector((s) => s.qcConfirmApproveApproveSlice);

  const dispatch = useAppDispatch();

  const {
    filterRowProps,
    datas,
    handlePageChange,

    p,
    // handleClearFilterModal,
    hideFilter,
  } = props;
  const [page, setPage] = useState(1);
  const handleDataFromChild = (e) => {
    setPage(e);
    // Do something with the data received from the child component
  };
  const [searchValue, setSearchValue] = React.useState("");
  const handleInputChange = (event) => {
    let inputValue = event.target.value;
    setSearchValue(inputValue);
    if (!inputValue) {
      filtersReset();
    }
  };

  //   const {
  //     data: VIDEOList,
  //     isLoading,
  //     refetch,
  //   } = useQuery(
  //     ["VIDEOList", page, receivedData],

  //     async () => {
  //       return CopywritersDashboardpendingtitlingpageMutation({
  //         urgent_request: receivedData === true ? 1 : "",
  //         pending_titling: 1,
  //         page: page,
  //       });
  //     }
  //   );
  const [receivedData, setReceivedData] = useState(null);
  const handleDataFromChild1 = (data) => {
    setReceivedData(data);
    if (data == true) {
      refetchAgain();
    }
  };
  const {
    data: VIDEOList,
    isLoading,

    refetch: refetchAgain,
  } = useQuery(
    ["VIDEOList", props?.selectedId, page, receivedData],

    async () => {
      return CopywritersDashboardPendingRevisionMutation({
        // urgent_request: receivedData === true ? 1 : "",
        revision_request: 1,
        page: page,
        // search: searchValue,

        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
      });
    }
  );
  console.warn(
    "🚀 ~ file: PendingTitlingRevisedTable.jsx:764 ~ PendingTitlingRevisedTable ~ VIDEOList:RR",
    VIDEOList
  );
  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };
  const handlePageChange2 = (p) => {
    setPage(p);
    handleTriggreFetch();
  };
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const filterRefetch = () => {
    refetchAgain();

    setOpenFilterModal(false);
  };

  const filtersReset = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setManagerId(null));
    setSearchValue("");
    dispatch(setHasMessage(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };

  const handleClearFilterModal = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setManagerId(null));
    dispatch(setHasMessage(null));
    // dispatch(setDuplicates(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };
  useEffect(() => {
    refetchAgain();
  }, [fetchTrigger]);

  const [filterActive, setFilterActive] = useState(false);

  // Define a function to receive data from the child component

  useEffect(() => {
    if (
      // search ||
      has_note ||
      unreachable_submitter ||
      hasMessage ||
      month ||
      year ||
      submit_place ||
      user_id ||
      manager_id ||
      quality_team_id ||
      people_appearing ||
      person_who_filmed ||
      submit_other_website ||
      aggrement_with_another_company
    ) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [
    user_id,
    month,
    year,
    submit_place,
    // search,
    has_note,
    unreachable_submitter,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    quality_team_id,
    manager_id,
    hasMessage,
  ]);

  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };

  const [videopopupModal, setVideopopupModal] = React.useState(false);
  const [videoId, setvideoId] = useState("");

  const handleOpen = (event) => {
    // return {};
    setvideoId(event);
    setVideopopupModal(true);
  };
  const handleClose = () => setVideopopupModal(false);

  const videoRef = useRef();

  // console.warn('source', source)

  function updateQuality(newQaulity) {
    window.hls.levels.forEach((level, levelIndex) => {
      if (level.height === newQaulity) {
        window.hls.currentLevel = levelIndex;
      }
    });
  }
  const handleContentLoaded = () => {
    // console.warn("call");
    var video = videoRef.current;
    // var source = source;

    const defaultOptions = {};

    if (Hls.isSupported()) {
      // console.warn("support");
      const hls = new Hls();
      hls.loadSource(videoId);
      hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
        const availableQualities = hls.levels.map((l) => l.height);
        defaultOptions.controls = [
          "play",
          "current-time",
          "progress",
          "duration",
          "fast-forward",
          "mute",
          "settings",
          "fullscreen",
        ];
        defaultOptions.quality = {
          default: availableQualities[0],
          options: availableQualities,
          forced: true,
          onChange: (e) => updateQuality(e),
        };
        new Plyr(video, defaultOptions);
      });
      hls.attachMedia(video);
      window.hls = hls;
    }
  };

  useEffect(() => {
    handleContentLoaded();
  }, []);

  const [openModalTwo, setOpenModalTwo] = useState(false);

  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  return (
    <>
      <Box className={`${styles.table_sec} ${styles1.cpPendingTitlingTable}`}>
        <CopywritePendingRivisionFilter
          {...filterRowProps}
          filterActive={filterActive}
          VIDEOList={VIDEOList?.data}
          sendDataToParent1={handleDataFromChild1}
          FilterModalComponent={QcWebsiteonlyRejectedFilterModal}
          filterModalProps={{
            searchValue,
            setSearchValue,
            openFilterModal,
            handleTriggreFetch,
            hideBottom: false,
            setOpenFilterModal,
            filterRefetch,
            filtersReset,
            handleClearFilterModal,
            handleInputChange,

            p,
            states: {
              // search,
              has_note,
              unreachable_submitter,
              hasMessage,
              month,
              year,
              submit_place,
              user_id,
              manager_id,
              quality_team_id,
              people_appearing,
              person_who_filmed,
              submit_other_website,
              aggrement_with_another_company,
              from,
              to,
            },
            setStates: {
              setHasNote,
              setUnreachableSubmitter,
              setHasMessage,
              setMonth,
              setYear,
              setSubmitPlace,
              setUserId,
              setManagerId,
              setQualityTeamId,
              setPeopleAppearing,
              setPersonWhoFilmed,
              setSubmitOtherWebsite,
              setAgreementWithAnotherCompany,
              setFrom,
              setTo,
            },
          }}
        />
        <Box className={`${styles1.cpPendingTitling}`}>
          <Box className={styles1.pendingTitlingTable}>
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={styles1.vsid}>VSID</TableCell>
                    {/* <TableCell className={styles.acqui}>Acquisitor</TableCell> */}
                    <TableCell className={styles1.thumnail}>
                      Thumbnail
                    </TableCell>
                    <TableCell className={styles1.tableTitle}>title</TableCell>
                    <TableCell className={styles1.team}>
                      Requester Comment
                    </TableCell>
                    <TableCell className={styles1.pendingSince}>
                      Pending Revision since
                    </TableCell>
                    <TableCell className={styles1.view} align="center">
                      View
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading ? (
                    <ApiLoader loading={isLoading} />
                  ) : (
                    <>
                      {VIDEOList?.data?.data?.map((row) => (
                        <>
                          <TableRow
                            className={`${
                              row.type === "highlight"
                                ? `${styles.trHighlight}`
                                : null
                            }`}
                          >
                            <TableCell scope="row">
                              <Box
                                className={`${styles.vsid_code} ${styles1.vsid_code}`}
                              >
                                <p>{row?.id}</p>
                              </Box>
                            </TableCell>

                            <TableCell sx={{ lineHeight: "0" }}>
                              <Box className={styles1.thumb_img}>
                                <Button
                                  onClick={() => onOpenTwo(row.id)}
                                  sx={{ padding: "0" }}
                                >
                                  <img
                                    src={concatHostAndImagePath(row?.thumbnail)}
                                    width={73}
                                    height={46}
                                    alt="image"
                                    className={styles.thumImg}
                                  />
                                </Button>
                              </Box>
                            </TableCell>

                            <TableCell>
                              <Box className={styles1.tilte}>{row?.title}</Box>
                            </TableCell>
                            <TableCell className={styles.thEditorTags}>
                              <Box className={styles1.teamNote}>
                                {row?.video_extra?.revision_request_comment ===
                                null ? (
                                  "N/A "
                                ) : (
                                  <>
                                    {row?.video_extra?.revision_request_comment}
                                  </>
                                )}
                              </Box>
                            </TableCell>

                            <TableCell>
                              <Box
                                variant="body2"
                                className={styles1.pendingTitle}
                              >
                                {row.video_meta.revision_requested_at ===
                                null ? (
                                  "N/A "
                                ) : (
                                  <>
                                    {getUtcDate(
                                      row.video_meta.revision_requested_at
                                    )}{" "}
                                    <br />
                                    {getUtcTime(
                                      row.video_meta.revision_requested_at
                                    )}
                                  </>
                                )}
                              </Box>
                            </TableCell>

                            <TableCell align="center">
                              <Box className={styles.table_view}>
                                <img
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onOpen(row.vsid)}
                                  src={assest.IconView}
                                  width={16}
                                  height={16}
                                  alt="icon"
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow className={styles1.blnkTd}>
                            <TableCell colSpan={7}>{""}</TableCell>
                          </TableRow>
                        </>
                      ))}
                      {VIDEOList?.data?.data?.length > 0 ? (
                        <TableRow className={styles.nonHover}>
                          <TableCell colSpan={10}>
                            {VIDEOList?.data.data.length <
                              VIDEOList?.data?.per_page &&
                            VIDEOList?.data.last_page == 1 ? (
                              <>
                                <p className={styles.endListMsg}>
                                  End of list. We couldn't find more videos
                                  matching your selected filter(s).
                                </p>
                              </>
                            ) : (
                              <>
                                <PaginationTwo
                                  page={page}
                                  count={VIDEOList?.data?.last_page}
                                  handleChange={handlePageChange2}
                                />
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      ) : (
                        <TableRow className={styles.nonHover}>
                          <TableCell colSpan={10}>
                            {filterActive ? (
                              <Filter resetFilters={filtersReset} />
                            ) : (
                              <>
                                {searchValue === "" ? (
                                  <NoResultTwo heading="pending" />
                                ) : (
                                  <Box
                                    className={`${styles.dateRangeNoresult} ${styles.emptyResult}`}
                                  >
                                    <Box className={styles.noFilter}>
                                      <figure>
                                        <SearchOopsIcon />
                                      </figure>
                                      <Typography variant="body1">
                                        We couldn’t find any matching approved
                                        videos for
                                        <span>{props?.name}</span>.
                                      </Typography>
                                    </Box>
                                  </Box>
                                )}
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      )}
                    </>
                  )}

                  <ApiLoader loading={isLoading} />
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* <Modal
          open={videopopupModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Text in a modal
            </Typography>
            
             
                       <Box
                      className={styles.videoBox}
                      // onClick={handleClickOpenProceed}
                       >
                   
                      <HlsPalyer
                        source={concatHostAndVideoPath(videoId)}
                      />
                    </Box>
          </Box>
                    </Modal> */}

          <WatchVideoModal
            onClose={onCloseTwo}
            open={openModalTwo}
            id={id}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videoPageModal"
          />
          <VideoPageFullModal
            onClose={onClose}
            open={openModal}
            id={id}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videoPageModal"
          />
        </Box>
      </Box>

      <Dialog
        // fullScreen
        open={videopopupModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box className={styles1.videoWrapper}>
          <Box className={styles1.videoWrapperLeft}>
            <Box className="VideocommonBox">
              <Box className={styles1.videoSection}>
                <Box className={styles1.videoBox}>
                  {/* <HlsPalyer source={concatHostAndVideoPath(videoId)} /> */}

                  <video ref={videoRef}></video>
                  {/* <video src="http://techslides.com/demos/sample-videos/small.mp4" controls></video> */}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default PendingTitlingRevisedTable;
